import React, { useState } from 'react'
import {
  AppBar,
  Toolbar,
  useScrollTrigger,
  Slide,
  CssBaseline,
  Typography,
  Tabs,
  Tab,
  Button,
  SwipeableDrawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  Hidden,
  useTheme,
  Grid,
  Avatar
} from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu'
import HomeIcon from '@material-ui/icons/Home'
import MovieIcon from '@material-ui/icons/Movie'
import GamesIcon from '@material-ui/icons/Games'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import VpnKeyIcon from '@material-ui/icons/VpnKey'
import Cookie from 'js-cookie'
import { useHistory } from 'react-router-dom'
import useStyles from './styles'
import { useStore } from '../../context/Context'

function HideOnScroll({ children }) {
  const trigger = useScrollTrigger()

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  )
}

const Navbar = ({ props }) => {
  const classes = useStyles()
  const history = useHistory()
  const { selectedTab, setSelectedTab, setOpenModal, isLogin, setIsLogin, setMessage, setSelectedDrawer } = useStore()

  const handleSelectedTab = (e, newValue) => setSelectedTab(newValue)

  const logout = async () => {
    await Cookie.remove('name')
    await Cookie.remove('email')
    await Cookie.remove('token')
    setMessage(state => ({
      ...state,
      msg: 'You\'ve been logged out',
      open: true,
      severty: 'success'
    }))
    setOpenModal(false)
    setIsLogin(false)
    history.push('/')
  }

  const [openRightDrawer, setOpenRightDrawer] = useState(false)
  const theme = useTheme()
  const initialName = Cookie.get('name') === undefined ? '' : Cookie.get('name').split(' ').map(s => s[0]).join('')

  const toggleDrawer = (open) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }

    setOpenRightDrawer(open)
  }

  const drawer = (
    <>
      <IconButton style={{ marginLeft: 'auto' }} onClick={toggleDrawer(true)}>
        <MenuIcon fontSize="large" color="primary" />
      </IconButton>
      <SwipeableDrawer
        anchor='right'
        open={openRightDrawer}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
      >
        <div
          className={classes.list}
          role="presentation"
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
        >
          <List>
            {Cookie.get('name') !== undefined && (
              <>
                <Grid container direction="column" alignItems="center" spacing={2}>
                  <Grid item>
                    <Avatar
                      alt="avatar"
                      className={classes.avatar}
                    >
                      {initialName}
                    </Avatar>
                  </Grid>
                  <Grid item>
                    <Typography variant="h6">{Cookie.get('name')}</Typography>
                  </Grid>
                </Grid>
                <Divider style={{ margin: '1em 0' }} />
              </>
            )}
            <ListItem
              button
              selected={selectedTab === 0}
              onClick={() => {
                setSelectedTab(0)
                setSelectedDrawer(null)
                history.push('/')
              }}
              className={classes.listItem}
            >
              <ListItemIcon><HomeIcon style={{ color: selectedTab === 0 ? theme.palette.primary.main : 'rgba(0, 0, 0, 0.3)' }} /></ListItemIcon>
              <ListItemText primary="Home" style={{ color: selectedTab === 0 ? theme.palette.primary.main : 'rgba(0, 0, 0, 0.3)' }} />
            </ListItem>
            <ListItem
              button
              selected={selectedTab === 1}
              onClick={() => {
                setSelectedTab(1)
                setSelectedDrawer(null)
                history.push('/movies')
              }}
              className={classes.listItem}
            >
              <ListItemIcon><MovieIcon style={{ color: selectedTab === 1 ? theme.palette.primary.main : 'rgba(0, 0, 0, 0.3)' }} /></ListItemIcon>
              <ListItemText primary="Movies" style={{ color: selectedTab === 1 ? theme.palette.primary.main : 'rgba(0, 0, 0, 0.3)' }} />
            </ListItem>
            <ListItem
              button
              selected={selectedTab === 2}
              onClick={() => {
                setSelectedTab(2)
                setSelectedDrawer(null)
                history.push('/games')
              }}
              className={classes.listItem}
            >
              <ListItemIcon><GamesIcon style={{ color: selectedTab === 2 ? theme.palette.primary.main : 'rgba(0, 0, 0, 0.3)' }} /></ListItemIcon>
              <ListItemText primary="Games" style={{ color: selectedTab === 2 ? theme.palette.primary.main : 'rgba(0, 0, 0, 0.3)' }} />
            </ListItem>
            <Divider style={{ margin: '1em 0' }} />
            {isLogin ? (
              <ListItem
                button
                onClick={logout}
                className={classes.logout}
              >
                <ListItemIcon><ExitToAppIcon style={{ color: 'white' }} /></ListItemIcon>
                <ListItemText primary="Logout" />
              </ListItem>
            ) : (
              <ListItem
                button
                onClick={() => setOpenModal(true)}
                className={classes.enter}
              >
                <ListItemIcon><VpnKeyIcon style={{ color: 'white' }} /></ListItemIcon>
                <ListItemText primary="Sign In / Register" />
              </ListItem>
            )}
          </List>
        </div>
      </SwipeableDrawer>
    </>
  )

  const tabs = (
    <>
      <Tabs
        aria-label="menu tabs"
        classes={{ indicator: classes.indicator }}
        TabIndicatorProps={{ children: <span /> }}
        textColor="primary"
        value={selectedTab}
        onChange={handleSelectedTab}
        className={classes.tabs}
      >
        <Tab label="Home" disableRipple className={classes.tab} onClick={() => {
          setSelectedDrawer(null)
          history.push('/')
        }} />
        <Tab label="Movies" disableRipple className={classes.tab} onClick={() => {
          setSelectedDrawer(null)
          history.push('/movies')
        }} />
        <Tab label="Games" disableRipple className={classes.tab} onClick={() => {
          setSelectedDrawer(null)
          history.push('/games')
        }} />
      </Tabs>
      {isLogin ? (
        <Button variant="contained" disableFocusRipple className={classes.buttonLogout} onClick={logout} style={{ color: 'white' }}>Logout</Button>
      ) : (
        <Button variant="contained" disableFocusRipple className={classes.buttonLogin} onClick={() => setOpenModal(true)}>Sign in / Register</Button>
      )}
    </>
  )

  return (
    <>
      <CssBaseline />
      <HideOnScroll {...props}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <Typography variant="h5" className={classes.title} component={Button} onClick={() => history.push('/')}>
              GAM<span className={classes.primaryText}>MOVIES</span>
            </Typography>
            <Hidden smDown>
              {tabs}
            </Hidden>
            <Hidden mdUp>
              {drawer}
            </Hidden>
          </Toolbar>
        </AppBar>
      </HideOnScroll>
    </>
  )
}

export default Navbar